import apiClient from "./client";

export interface LoginRequest {
  email: string;
  password: string;
}

export interface TokenResponse {
  access_token: string;
  refresh_token: string;
  token_type: string;
}

export interface UserScope {
  scope_type: string;
  scope_value: string;
}

export interface UserRole {
  id: string;
  key: string;
  label: string;
}

export interface UserProfile {
  id: string;
  email: string;
  first_name: string;
  last_name: string;
  is_active: boolean;
  organization_id: string | null;
  organization_name: string | null;
  practice_slug: string | null;
  roles: UserRole[];
  permissions: string[];
  scopes: UserScope[];
}

export async function login(data: LoginRequest): Promise<TokenResponse> {
  const response = await apiClient.post<TokenResponse>("/auth/login", data);
  return response.data;
}

export async function getMe(): Promise<UserProfile> {
  const response = await apiClient.get<UserProfile>("/auth/me");
  return response.data;
}

export async function refreshToken(refresh_token: string): Promise<TokenResponse> {
  const response = await apiClient.post<TokenResponse>("/auth/refresh", { refresh_token });
  return response.data;
}

export async function logout(): Promise<void> {
  await apiClient.post("/auth/logout");
}

export interface ChangePasswordRequest {
  current_password: string;
  new_password: string;
}

/**
 * Self-service password change for the CALLER's own account (see
 * `POST /api/auth/change-password`). No user id is ever sent — the backend
 * always resolves the target from the caller's own JWT.
 */
export async function changePassword(data: ChangePasswordRequest): Promise<{ message: string }> {
  const response = await apiClient.post<{ message: string }>("/auth/change-password", data);
  return response.data;
}
